import { observer } from 'mobx-react'

import NavigatorHeader from 'modules/documents/components/DocumentNavigator/Header'
import { Document } from 'modules/documents/hooks/documents/useGetDocuments'

import Content from './Content'

export interface NavigatorContentProps {
  document: Document
  documents: Document[]
  index: number
  onCancel: () => void
  onClickBack: () => void
  onClickForward: () => void
}

interface Props {
  saving?: boolean
  disableFilleableConfirm?: boolean
  loading?: boolean
}

export interface DocumentViewerContentProps extends Props, NavigatorContentProps {}

const DocumentPreview = ({
  document,
  documents,
  index,
  onClickBack,
  onClickForward,
  onCancel,
  saving,
  disableFilleableConfirm,
  loading,
}: DocumentViewerContentProps) => (
  <>
    <NavigatorHeader
      document={document}
      documents={documents}
      index={index}
      onClickBack={onClickBack}
      onClickForward={onClickForward}
      onCancel={onCancel}
    />
    <Content
      document={document}
      saving={saving}
      disableFilleableConfirm={disableFilleableConfirm}
      loading={loading}
    />
  </>
)

export default observer(DocumentPreview)
